import {REQUEST_DICE} from "@actions/actionTypes";

export function setDice(dice) {
    return dispatch => {
        dispatch({type: REQUEST_DICE, dice})
    }
}